import React, { useContext } from 'react';

import { UploadedFile } from '../../../../api-client';
import { ymAsync } from '../../../../utils/functions/ymWrapper';
import IdentificationContext from '../../../context/IdentificationContext';
import IdentificationFileUpload from '../IdentificationFileUpload';

const SecondScanUpload = () => {
  const context: any = useContext(IdentificationContext);

  const loadFiles = (files: Array<UploadedFile>) => {
    ymAsync('verification-passport-2-input');
    context.setSecondPassportScans(files);
  };

  return (
    <IdentificationFileUpload
      prefix="second"
      text="Разворот с регистрацией"
      files={context.secondPassportScans}
      onUploaded={loadFiles}
    />
  );
};

export default SecondScanUpload;
